module.exports = __webpack_public_path__ + "img/挥动.6749716f.gif";